import { Bodies } from "matter-js";
import { COLLISION_CATEGORIES } from "../utils/constants";
import { AbstractEntity } from "./AbstractEntity";

export class WallConfig {
    id?: string;
    x: number;      // centro
    y: number;      // centro
    width: number;
    height: number;
    backgroundColor?: string; // Opcional: para personalizar el color de la pared
}

export class WallEntity extends AbstractEntity {
    constructor(config: WallConfig) {
        const element = document.createElement('div');
        element.classList.add('wall-node');
        element.style.width = `${config.width}px`;
        element.style.height = `${config.height}px`;
        element.style.backgroundColor = config.backgroundColor || 'rgba(0, 0, 0, 0.2)';
        element.style.pointerEvents = 'none';
        // Elemento puramente decorativo/físico: no debe ser percibido por lectores de pantalla
        element.setAttribute('aria-hidden', 'true');

        // centrado del elemento respecto a las coordenadas x, y
        element.style.position = 'absolute';
        element.style.top = '0';
        element.style.left = '0';

        const body = Bodies.rectangle(config.x, config.y, config.width, config.height, {
            label: 'WALL',
            isStatic: true,

            // FÍSICAS DE PARED SÓLIDA
            restitution: 0.1, // Casi no rebota
            friction: 0.2,    // Ligera fricción para que la burbuja se frene al rozar la pared
            slop: 0.01,       // REDUCIR PENETRACIÓN: Evita que la burbuja se "hunda" en la pared

            collisionFilter: {
                category: COLLISION_CATEGORIES.WALL,
                // mask: COLLISION_CATEGORIES.BUBBLE// | COLLISION_CATEGORIES.CLUSTER | COLLISION_CATEGORIES.INNER_BUBBLE
            }
        });

        super(element, body, undefined);

        if (config.id) {
            // @ts-ignore
            this._id = config.id;
        }
    }
}